import { useAppDispatch, useAppSelector, useErrTranslation } from 'app/hooks';
import { showErrorModal } from 'components/Modals/CommonModals';
import { HttpError } from 'models';
import { useCallback } from 'react';
import { selectCurrentUser, selectTokenPrice, setClearStateToLogout } from 'redux/userSlice';

const useHandleResponseError = () => {
  const dispatch = useAppDispatch();
  const et = useErrTranslation();
  const currentUser = useAppSelector(selectCurrentUser);

  const tokenPrice = useAppSelector(selectTokenPrice);
  const handleOK = () => {
    dispatch(setClearStateToLogout());
  };

  return useCallback(
    (error?: HttpError, onOk?: () => void) => {
      if (!error) {
        return null;
      }

      if (error.unauthorized) {
        if (error.message === 'Full authentication is required to access this resource') {
          handleOK();
          return undefined;
        }

        showErrorModal({
          content: et(error.message),
          onOk,
          title: et(error.title || '', { defaultValue: et('defaultMessage.title') }),
        });
      }

      if (error.serverError || (error.badRequest && !error.fieldErrors)) {
        if (error.message === 'error.bet-amount.limit-exceeded') {
          showErrorModal({
            content: et(error.message, {
              betMinAmount:
                currentUser?.coinDto.symbol === '$TBET'
                  ? Number(currentUser?.betMinAmount) / tokenPrice + currentUser?.coinDto.symbol
                  : currentUser?.betMinAmount + '$',
              liveBetMaxWinAmount:
                currentUser?.coinDto.symbol === '$TBET'
                  ? Number(currentUser?.liveBetMaxWinAmount) / tokenPrice +
                    currentUser?.coinDto.symbol
                  : currentUser?.liveBetMaxWinAmount + '$',
              betMaxWinAmount:
                currentUser?.coinDto.symbol === '$TBET'
                  ? Number(currentUser?.betMaxWinAmount) / tokenPrice + currentUser?.coinDto.symbol
                  : currentUser?.betMaxWinAmount + '$',
            }),
            onOk,
            title: et(error.title || '', { defaultValue: et('defaultMessage.title') }),
          });
        } else if (error.message === 'error.future-bet-amount.limit-exceeded') {
          showErrorModal({
            content: et(error.message, {
              betMinAmount: currentUser?.betMinAmount,
              futureBetMaxWinAmount: currentUser?.futureBetMaxWinAmount,
            }),
            onOk,
            title: et(error.title || '', { defaultValue: et('defaultMessage.title') }),
          });
        } else {
          showErrorModal({
            content: et(error.message),
            onOk,
            title: et(error.title || '', { defaultValue: et('defaultMessage.title') }),
          });
        }
      }

      return undefined;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, et, currentUser, tokenPrice, currentUser?.coinDto.symbol],
  );
};

export { useHandleResponseError };
